/* eslint-disable*/
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../config';
import { InputBox, SubmitButton, TextAreaBox, DropdownBox, CheckBox } from '../../components/Input';
import { showToast } from '../../components/toast';
import LoadingSpinner from "../../components/LoadingSpinner";


const EditStreetView = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  // Form state
  const [formData, setFormData] = useState({
    heading: '',
    heading_2: '',
    img_url: '',
    type: '1',
    img_url: '', 
    checksharing: '0',
    shareNotification: '0',
    nifty_title: '',
    nifty_previous_close: '',
    nifty_previous_day_change: '',
    nifty_intraday_supports: '',
    nifty_intraday_resistance: '',
    nifty_expected_opening: '',
    nifty_note: '',
    nifty_description: '',
    bankNifty_title: '',
    bankNifty_previous_close: '',
    bankNifty_previous_day_change: '',
    bankNifty_intraday_supports: '',
    bankNifty_intraday_resistance: '',
    bankNifty_expected_opening: '',
    bankNifty_note: '',
    bankNifty_description: '',
    sc_keytitle: '',
    sc_keydescription: '',
    sc_title: '',
    sc_description: '',
    highlights: []
  });

  const [marketData, setMarketData] = useState({
    asian: [],
    indian: [],
    european: [],
    us: [],
    summary: {
      us_market_summary: '',
      asian_market_summary: '',
      european_market_summary: '',
      global_summary: '',
      sensex: ''
    }
  });

  const [loading, setLoading] = useState(false);
  const [operation, setOperation] = useState('Add');
  const typeList = [
    { value: '1', label: 'SO' },
    { value: '2', label: 'SC' }
  ];

  // Fetch data on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const response = await axios.get(`${API_URL}newStreetView/form/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        console.log("response", response);

        if (response.data) {
          const data = response.data.data.streetview;
          setOperation('Edit');

          // Transform the data to match our form state
          const transformedData = {
            heading: data.heading || '',
            heading_2: data.heading_2 || '',
            featureimg: data.img_url || '',
            type: data.type || '1',
            checksharing: data.checksharing || '0',
            shareNotification: data.shareNotification || '0',
            highlights: data.market_highlights ? JSON.parse(data.market_highlights) : []
          };

          // Nifty 50 data
          if (data.nifty_50) {
            const niftyData = JSON.parse(data.nifty_50);
            transformedData.nifty_title = niftyData.nifty_title || '';
            transformedData.nifty_previous_close = niftyData.nifty_previous_close || '';
            transformedData.nifty_previous_day_change = niftyData.nifty_previous_day_change || '';
            transformedData.nifty_intraday_supports = niftyData.nifty_intraday_supports || '';
            transformedData.nifty_intraday_resistance = niftyData.nifty_intraday_resistance || '';
            transformedData.nifty_expected_opening = niftyData.nifty_expected_opening || '';
            transformedData.nifty_note = niftyData.nifty_note || '';
            transformedData.nifty_description = niftyData.nifty_description || '';
          }

          // BankNifty data
          if (data.banknifty) {
            const bankNiftyData = JSON.parse(data.banknifty);
            transformedData.bankNifty_title = bankNiftyData.bankNifty_title || '';
            transformedData.bankNifty_previous_close = bankNiftyData.bankNifty_previous_close || '';
            transformedData.bankNifty_previous_day_change = bankNiftyData.bankNifty_previous_day_change || '';
            transformedData.bankNifty_intraday_supports = bankNiftyData.bankNifty_intraday_supports || '';
            transformedData.bankNifty_intraday_resistance = bankNiftyData.bankNifty_intraday_resistance || '';
            transformedData.bankNifty_expected_opening = bankNiftyData.bankNifty_expected_opening || '';
            transformedData.bankNifty_note = bankNiftyData.bankNifty_note || '';
            transformedData.bankNifty_description = bankNiftyData.bankNifty_description || '';
          }

          // SC data
          if (data.sc_key) {
            const scKeyData = JSON.parse(data.sc_key);
            transformedData.sc_keytitle = scKeyData.sc_keytitle || '';
            transformedData.sc_keydescription = scKeyData.sc_keydescription || '';
          }

          if (data.sc_market) {
            const scMarketData = JSON.parse(data.sc_market);
            transformedData.sc_title = scMarketData.sc_title || '';
            transformedData.sc_description = scMarketData.sc_description || '';
          }

          setFormData(transformedData);

          // Fetch market data
          fetchMarketData(data.created_on);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    if (id) {
      fetchData();
    }
  }, [id]);

  const fetchMarketData = async (date) => {
    try {
      const response = await axios.get(`${API_URL}Research/NewStreetView/fetch_market_data_so`, {
        params: { date }
      });

      const data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;

      if (data) {
        setMarketData({
          asian: data.asian_market || [],
          indian: data.indian_market || [],
          european: data.european_market || [],
          us: data.us_market || [],
          summary: data.summary || {
            us_market_summary: '',
            asian_market_summary: '',
            european_market_summary: '',
            global_summary: '',
            sensex: ''
          }
        });
      }
    } catch (error) {
      console.error('Error fetching market data:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (checked ? '1' : '0') : value
    }));
  };

  const handleHighlightChange = (index, field, value) => {
    const updatedHighlights = [...formData.highlights];
    if (!updatedHighlights[index]) {
      updatedHighlights[index] = { highlight_title: '', highlight_description: '' };
    }
    updatedHighlights[index][field] = value;
    setFormData(prev => ({ ...prev, highlights: updatedHighlights }));
  };

  const addHighlight = () => {
    setFormData(prev => ({
      ...prev,
      highlights: [...prev.highlights, { highlight_title: '', highlight_description: '' }]
    }));
  };

  const removeHighlight = (index) => {
    setFormData(prev => ({
      ...prev,
      highlights: prev.highlights.filter((_, i) => i !== index)
    }));
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   try {
  //     const token = localStorage.getItem('authToken');
  //     const payload = {
  //       ...formData,
  //       nifty_50: JSON.stringify({
  //         nifty_title: formData.nifty_title,
  //         nifty_previous_close: formData.nifty_previous_close,
  //         nifty_previous_day_change: formData.nifty_previous_day_change,
  //         nifty_intraday_supports: formData.nifty_intraday_supports,
  //         nifty_intraday_resistance: formData.nifty_intraday_resistance,
  //         nifty_expected_opening: formData.nifty_expected_opening,
  //         nifty_note: formData.nifty_note,
  //         nifty_description: formData.nifty_description
  //       }),
  //       banknifty: JSON.stringify({
  //         bankNifty_title: formData.bankNifty_title,
  //         bankNifty_previous_close: formData.bankNifty_previous_close,
  //         bankNifty_previous_day_change: formData.bankNifty_previous_day_change,
  //         bankNifty_intraday_supports: formData.bankNifty_intraday_supports,
  //         bankNifty_intraday_resistance: formData.bankNifty_intraday_resistance,
  //         bankNifty_expected_opening: formData.bankNifty_expected_opening,
  //         bankNifty_note: formData.bankNifty_note,
  //         bankNifty_description: formData.bankNifty_description
  //       }),
  //       sc_key: JSON.stringify({
  //         sc_keytitle: formData.sc_keytitle,
  //         sc_keydescription: formData.sc_keydescription
  //       }),
  //       sc_market: JSON.stringify({
  //         sc_title: formData.sc_title,
  //         sc_description: formData.sc_description
  //       }),
  //       market_highlights: JSON.stringify(formData.highlights)
  //     };

  //     const url = id 
  //       ? `${API_URL}newStreetView/${id}`
  //       : `${API_URL}Research/NewStreetView/save`;

  //     const method = id ? 'put' : 'post';

  //     const response = await axios[method](url, payload, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         'Content-Type': 'application/json'
  //       }
  //     });

  //     if (response.data.success) {
  //       alert(`Street View ${operation === 'Add' ? 'created' : 'updated'} successfully!`);
  //       navigate('/Research/NewStreetView');
  //     } else {
  //       alert('Operation failed. Please try again.');
  //     }
  //   } catch (error) {
  //     console.error('Error submitting form:', error);
  //     alert('Something went wrong. Please try again.');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const token = localStorage.getItem("authToken");
    const formDataPayload = new FormData();

    formDataPayload.append("heading", formData.heading);
    formDataPayload.append("heading_2", formData.heading_2 || "");
    formDataPayload.append("checksharing", formData.checksharing || "0");
    formDataPayload.append("shareNotification", formData.shareNotification || "0");
    formDataPayload.append("type", formData.type || "1");

    // file/image handling
    if (formData.img_url instanceof File) {
      formDataPayload.append("img_url", formData.img_url); // real file
    } else if (formData.img_url) {
      // if just a URL string, backend might not accept it
      // better to keep it empty if no new upload
      formDataPayload.append("img_url", formData.img_url);
    }

    const response = await axios.put(`${API_URL}newStreetView/${id}`, formDataPayload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
        accept: "*/*",
      },
    });

    if (response.data.success) {
      showToast.success("Street View updated successfully", "success");
      navigate("/research/StreetView");
    } else {
      showToast.error("Failed to update Street View", "error");
    }
  } catch (error) {
    console.error("Error submitting form:", error);
    showToast.error("Something went wrong. Please try again.", "error");
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="page-container page-header-fixed page-sidebar-fixed fade in mt-5">
      <div className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <form onSubmit={handleSubmit} className="stdform">
            <input type="hidden" name="id" value={id} />
            <div className="panel-heading border-0">
              <span className="panel-title">{operation} NewStreetView</span>
            </div>

            <div className="panel-body">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <InputBox
                    label="Heading"
                    fieldname="heading"
                    placeholder="Enter Heading"
                    value={formData.heading}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <InputBox
                    label="Heading 2"
                    fieldname="heading_2"
                    placeholder="Enter Heading"
                    value={formData.heading_2}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <InputBox
                    label="Image Url"
                    fieldname="featureimg"
                    placeholder="Enter Image Url"
                    value={formData.featureimg}
                    onChange={handleChange}
                  />
                </div>
                {/* <div className="col-md-6 mb-3">
                  <DropdownBox
                    label="Type"
                    fieldname="type"
                    options={typeList}
                    value={formData.type}
                    onChange={handleChange}
                  />
                </div> */}
                <div className="col-md-6 mb-3">
                  <CheckBox
                    label="Publish StreetView"
                    fieldname="checksharing"
                    checked={formData.checksharing === '1'}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Highlights Section */}
              {/* <div className="row addIcon" id="addIcon">
                {formData.highlights.map((highlight, index) => (
                  <div className="col-md-3 addIconBox mb-3" key={index}>
                    <InputBox
                      label={`Highlight ${index + 1} Title`}
                      fieldname={`highlight_title_${index}`}
                      value={highlight.highlight_title || ''}
                      onChange={(e) => handleHighlightChange(index, 'highlight_title', e.target.value)}
                    />
                    <InputBox
                      label={`Highlight ${index + 1} Description`}
                      fieldname={`highlight_description_${index}`}
                      value={highlight.highlight_description || ''}
                      onChange={(e) => handleHighlightChange(index, 'highlight_description', e.target.value)}
                    />
                    <button
                      type="button"
                      className="btn btn-danger mt-2"
                      onClick={() => removeHighlight(index)}
                      disabled={loading}
                    >
                      Remove
                    </button>
                  </div>
                ))}
              </div>
              <button
                type="button"
                className="btn btn-success my-2"
                onClick={addHighlight}
                disabled={loading}
              >
                Add Highlight
              </button>
              <hr /> */}

              {/* Nifty 50 Section */}
              {/* <div className="panel-heading dropdown-item">
                <span className="panel-title">Nifty 50 Outlook</span>
              </div>
              <div className="row">
                <div className="col-md-3 mb-3">
                  <InputBox
                    label="Title"
                    fieldname="nifty_title"
                    placeholder="Enter Title"
                    value={formData.nifty_title}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <InputBox
                    label="Previous Close"
                    fieldname="nifty_previous_close"
                    placeholder="Enter Previous Close"
                    value={formData.nifty_previous_close}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <InputBox
                    label="Previous Day Change"
                    fieldname="nifty_previous_day_change"
                    placeholder="Enter Previous Day Change"
                    value={formData.nifty_previous_day_change}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <InputBox
                    label="Intraday Supports"
                    fieldname="nifty_intraday_supports"
                    placeholder="Enter Intraday Supports"
                    value={formData.nifty_intraday_supports}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <InputBox
                    label="Intraday Resistance"
                    fieldname="nifty_intraday_resistance"
                    placeholder="Enter Intraday Resistance"
                    value={formData.nifty_intraday_resistance}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <InputBox
                    label="Expected Opening"
                    fieldname="nifty_expected_opening"
                    placeholder="Enter Expected Opening"
                    value={formData.nifty_expected_opening}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <InputBox
                    label="Note"
                    fieldname="nifty_note"
                    placeholder="Enter Note"
                    value={formData.nifty_note}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-12 mb-3">
                  <TextAreaBox
                    label="Description"
                    fieldname="nifty_description"
                    placeholder="Enter Description"
                    value={formData.nifty_description}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <hr /> */}

              {/* BankNifty Section */}
              {/* <div className="panel-heading dropdown-item">
                <span className="panel-title">BankNifty 50 Outlook</span>
              </div>
              <div className="row">
                <div className="col-md-3 mb-3">
                  <InputBox
                    label="Title"
                    fieldname="bankNifty_title"
                    placeholder="Enter Title"
                    value={formData.bankNifty_title}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <InputBox
                    label="Previous Close"
                    fieldname="bankNifty_previous_close"
                    placeholder="Enter Previous Close"
                    value={formData.bankNifty_previous_close}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <InputBox
                    label="Previous Day Change"
                    fieldname="bankNifty_previous_day_change"
                    placeholder="Enter Previous Day Change"
                    value={formData.bankNifty_previous_day_change}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <InputBox
                    label="Intraday Supports"
                    fieldname="bankNifty_intraday_supports"
                    placeholder="Enter Intraday Supports"
                    value={formData.bankNifty_intraday_supports}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <InputBox
                    label="Intraday Resistance"
                    fieldname="bankNifty_intraday_resistance"
                    placeholder="Enter Intraday Resistance"
                    value={formData.bankNifty_intraday_resistance}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <InputBox
                    label="Expected Opening"
                    fieldname="bankNifty_expected_opening"
                    placeholder="Enter Expected Opening"
                    value={formData.bankNifty_expected_opening}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <InputBox
                    label="Note"
                    fieldname="bankNifty_note"
                    placeholder="Enter Note"
                    value={formData.bankNifty_note}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-12 mb-3">
                  <TextAreaBox
                    label="Description"
                    fieldname="bankNifty_description"
                    placeholder="Enter Description"
                    value={formData.bankNifty_description}
                    onChange={handleChange}
                  />
                </div>
              </div> */}

              {/* SC Section */}
              <div className="row">
                <div className="col-md-12 mb-3">
                  <CheckBox
                    label="Send Notifications"
                    fieldname="shareNotification"
                    checked={formData.shareNotification === '1'}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-group">
                <SubmitButton 
                  pageBack="/research/StreetView" 
                  handleSubmit={handleSubmit} 
                  disabled={loading}
                />
                {loading && (
                  <LoadingSpinner />
                )}
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* Market Data Tables */}
      <div className="m-15">
        {/* Asian Market */}
        {/* <div className="row">
          <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
            <div className="panel-heading">
              <span className="panel-title">Asian Market</span>
            </div>
            <div className="panel-body">
              <div className="table-responsive">
                <table className="table table-condensed table-bordered bg-white">
                  <thead>
                    <tr>
                      <th>Index Name</th>
                      <th>High</th>
                      <th>Prev. Close</th>
                      <th>New 52 Week Low</th>
                      <th>Chg%</th>
                      <th>Technical Rating</th>
                      <th>52 W High</th>
                      <th>LTP</th>
                      <th>Change (%)</th>
                      <th>Open</th>
                      <th>Open Percentage</th>
                      <th>Low</th>
                      <th>YTD (%)</th>
                      <th>Outlook</th>
                    </tr>
                  </thead>
                  <tbody>
                    {marketData.asian.length > 0 ? (
                      marketData.asian.map((market, index) => (
                        <tr key={index}>
                          <td>{market.index_name}</td>
                          <td>{market.index_data.High}</td>
                          <td>{market.index_data['Prev. Close']}</td>
                          <td>{market.index_data['52 W Low']}</td>
                          <td>{market.index_data['Chg%']}</td>
                          <td>{market.index_data['Technical Rating']}</td>
                          <td>{market.index_data['52 W High']}</td>
                          <td>{market.index_data.LTP}</td>
                          <td>{market.index_data.Change}</td>
                          <td>{market.index_data.Open}</td>
                          <td>{market.index_data.open_percentage}</td>
                          <td>{market.index_data.Low}</td>
                          <td>{market.index_data['YTD (%)']}</td>
                          <td>{market.index_data.outlook}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="14">No data available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div> */}

        {/* Indian Market */}
        {/* <div className="row">
          <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
            <div className="panel-heading">
              <span className="panel-title">Indian Market</span>
            </div>
            <div className="panel-body">
              <div className="table-responsive">
                <table className="table table-condensed table-bordered bg-white">
                  <thead>
                    <tr>
                      <th>Index Name</th>
                      <th>Day Change</th>
                      <th>Open Percentage</th>
                      <th>High</th>
                      <th>Last Traded</th>
                      <th>Change Percentage</th>
                      <th>Low</th>
                      <th>Change</th>
                      <th>Outlook</th>
                      <th>Open</th>
                      <th>Prev. Close</th>
                    </tr>
                  </thead>
                  <tbody>
                    {marketData.indian.length > 0 ? (
                      marketData.indian.map((market, index) => (
                        <tr key={index}>
                          <td>{market.index_name}</td>
                          <td>{market.index_data.day_change}</td>
                          <td>{market.index_data.open_percentage}</td>
                          <td>{market.index_data.high}</td>
                          <td>{market.index_data.last_traded}</td>
                          <td>{market.index_data.change_percentage}</td>
                          <td>{market.index_data.low}</td>
                          <td>{market.index_data.change}</td>
                          <td>{market.index_data.outlook}</td>
                          <td>{market.index_data.open}</td>
                          <td>{market.index_data.prev_close}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="11">No data available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div> */}

        {/* European Market */}
        {/* <div className="row">
          <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
            <div className="panel-heading">
              <span className="panel-title">European Market</span>
            </div>
            <div className="panel-body">
              <div className="table-responsive">
                <table className="table table-condensed table-bordered bg-white">
                  <thead>
                    <tr>
                      <th>Index Name</th>
                      <th>High</th>
                      <th>Prev. Close</th>
                      <th>New 52 Week Low</th>
                      <th>Chg%</th>
                      <th>Technical Rating</th>
                      <th>52 W High</th>
                      <th>LTP</th>
                      <th>Change (%)</th>
                      <th>Open</th>
                      <th>Open Percentage</th>
                      <th>Low</th>
                      <th>YTD (%)</th>
                      <th>Outlook</th>
                    </tr>
                  </thead>
                  <tbody>
                    {marketData.european.length > 0 ? (
                      marketData.european.map((market, index) => (
                        <tr key={index}>
                          <td>{market.index_name}</td>
                          <td>{market.index_data.High}</td>
                          <td>{market.index_data['Prev. Close']}</td>
                          <td>{market.index_data['52 W Low']}</td>
                          <td>{market.index_data['Chg%']}</td>
                          <td>{market.index_data['Technical Rating']}</td>
                          <td>{market.index_data['52 W High']}</td>
                          <td>{market.index_data.LTP}</td>
                          <td>{market.index_data.Change}</td>
                          <td>{market.index_data.Open}</td>
                          <td>{market.index_data.open_percentage}</td>
                          <td>{market.index_data.Low}</td>
                          <td>{market.index_data['YTD (%)']}</td>
                          <td>{market.index_data.outlook}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="14">No data available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div> */}

        {/* US Market */}
        {/* <div className="row">
          <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
            <div className="panel-heading">
              <span className="panel-title">US Market</span>
            </div>
            <div className="panel-body">
              <div className="table-responsive">
                <table className="table table-condensed table-bordered bg-white">
                  <thead>
                    <tr>
                      <th>Index Name</th>
                      <th>High</th>
                      <th>Prev. Close</th>
                      <th>New 52 Week Low</th>
                      <th>Chg%</th>
                      <th>Technical Rating</th>
                      <th>52 W High</th>
                      <th>LTP</th>
                      <th>Change (%)</th>
                      <th>Open</th>
                      <th>Open Percentage</th>
                      <th>Low</th>
                      <th>YTD (%)</th>
                      <th>Outlook</th>
                    </tr>
                  </thead>
                  <tbody>
                    {marketData.us.length > 0 ? (
                      marketData.us.map((market, index) => (
                        <tr key={index}>
                          <td>{market.index_name}</td>
                          <td>{market.index_data.High}</td>
                          <td>{market.index_data['Prev. Close']}</td>
                          <td>{market.index_data['52 W Low']}</td>
                          <td>{market.index_data['Chg%']}</td>
                          <td>{market.index_data['Technical Rating']}</td>
                          <td>{market.index_data['52 W High']}</td>
                          <td>{market.index_data.LTP}</td>
                          <td>{market.index_data.Change}</td>
                          <td>{market.index_data.Open}</td>
                          <td>{market.index_data.open_percentage}</td>
                          <td>{market.index_data.Low}</td>
                          <td>{market.index_data['YTD (%)']}</td>
                          <td>{market.index_data.outlook}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="14">No data available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div> */}

        {/* Summary Section */}
        {/* <div className="row">
          <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
            <div className="panel-heading">
              <span className="panel-title">Summary</span>
            </div>
            <div className="panel-body">
              <table className="table table-condensed table-bordered bg-white">
                <tbody>
                  <tr>
                    <td>US Market Summary</td>
                    <td>{marketData.summary.us_market_summary || 'No summary available'}</td>
                  </tr>
                  <tr>
                    <td>Asian Market Summary</td>
                    <td>{marketData.summary.asian_market_summary || 'No summary available'}</td>
                  </tr>
                  <tr>
                    <td>European Market Summary</td>
                    <td>{marketData.summary.european_market_summary || 'No summary available'}</td>
                  </tr>
                  <tr>
                    <td>Global Market Summary</td>
                    <td>{marketData.summary.global_summary || 'No summary available'}</td>
                  </tr>
                  <tr>
                    <td>Sensex Summary</td>
                    <td>{marketData.summary.sensex || 'No summary available'}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div> */}
      </div>

      {/* Scroll top button */}
      <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
        <i className="ti-arrow-up"></i>
      </a>
    </div>
  );
};

export default EditStreetView;